import { render, staticRenderFns } from "./EditService.vue?vue&type=template&id=44af428e&"
import script from "./EditService.vue?vue&type=script&lang=ts&"
export * from "./EditService.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports